module.exports = __webpack_public_path__ + "img/icon-twitter.75af8d6e.svg";